<template>
  <div class="nearby-eat">
    <div class="container">
      <h2 class="page-title blue">{{ title }}</h2>
      <div
        v-swiper:mySwiper="swiperOption(swiperSize)"
        class="swiper-container"
      >
        <div class="swiper-wrapper">
          <kcs-facility-eat-item
            :eat="eat"
            v-for="(eat, index) in eats"
            :key="index"
            @click.native="
              handleAnalyticsTrackEvent('facility_eat', 'click', 'eat_link', 1)
            "
          />
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <p class="hotpepper-license">
        <a
          href="https://webservice.recruit.co.jp/"
          target="_blank"
          rel="nofollow"
          ><img
            src="https://webservice.recruit.co.jp/banner/hotpepper-s.gif"
            alt="ホットペッパー Webサービス"
            width="135"
            height="17"
            border="0"
            title="ホットペッパー Webサービス"
        /></a>
        <span>画像提供：ホットペッパー グルメ</span>
      </p>
    </div>
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
import KcsFacilityEatItem from '~/components/molecules/kcs-facility-eat-item.vue'
export default {
  components: {
    KcsFacilityEatItem
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    eats: {
      type: Array,
      required: true
    },
    isSmallGallery: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return this.detail.name + '周辺でランチ・ディナーにおすすめのレストラン'
    },
    swiperSize() {
      return this.isSmallGallery ? 4 : 3
    }
  },
  methods: {
    swiperOption(size) {
      return methods.swiperOption(size)
    }
  }
}
</script>
